import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'

import { MultiSelect } from '../../components'

const ContentItemSelectionTopicBox = props => {
  const handleSelectAll = () => {
    let groupData = { ...props.group }
    let itemData = props.group.items.map(item => {
      let newItem = { ...item }
      newItem.selected = !groupData.all_selected
      return newItem
    })
    groupData.all_selected = !groupData.all_selected
    groupData['items'] = itemData
    props.updateGroupFunc(groupData)
  }

  const handleSelect = event => {
    let groupData = { ...props.group }
    groupData['all_selected'] = true
    let itemData = props.group.items.map(item => {
      let newItem = { ...item }
      if (newItem.pk === event.target.value) {
        newItem.selected = !newItem.selected
      }
      if (newItem.selected === false) {
        groupData['all_selected'] = false
      }
      return newItem
    })
    groupData['items'] = itemData
    props.updateGroupFunc(groupData)
  }

  const group = { ...props.group }
  const _button = (
    <Button className="pull-right mt-1 mr-4" onClick={handleSelectAll}>
      {group.all_selected ? 'Unselect All' : 'Select All'}
    </Button>
  )
  const selectAllBtn = props.acceptMultiple ? _button : null

  return (
    <div>
      <div className="shadow p-2 bg-white rounded pb-4 mb-5">
        {selectAllBtn}
        <MultiSelect
          contentArray={group.items.map(item => ({
            name: item.title,
            checked: item.selected,
            id: item.pk,
          }))}
          label={group.title}
          onSelected={handleSelect}
        />
      </div>
    </div>
  )
}

ContentItemSelectionTopicBox.propTypes = {
  group: PropTypes.object.isRequired,
  updateGroupFunc: PropTypes.func.isRequired,
  acceptMultiple: PropTypes.bool,
}

export default ContentItemSelectionTopicBox
